var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-container"},[_c('nav-component'),_vm._v(" "),_c('header-home'),_vm._v(" "),_c('newsletter-signup'),_vm._v(" "),_c('happy'),_vm._v(" "),_c('testimonials'),_vm._v(" "),_c('packages'),_vm._v(" "),_c('packages-signup'),_vm._v(" "),_c('juicer'),_vm._v(" "),_c('booking-signup'),_vm._v(" "),_c('site-map'),_vm._v(" "),_c('footer-component')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-129a9f4b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 73
// module chunks = 0